import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Loader = createSvgIcon(({ color }) => (
  <g fill={color} fillRule="evenodd" stroke="none" strokeWidth="1" clipRule="evenodd">
    <path
      d="M50 5.013C25.154 5.013 5.013 25.154 5.013 50c0 24.846 20.142 44.987 44.987 44.987 24.846 0 44.987-20.141 44.987-44.987C94.987 25.154 74.846 5.013 50 5.013zM0 50C0 22.386 22.386 0 50 0s50 22.386 50 50-22.386 50-50 50S0 77.614 0 50z"
      opacity="0.25"
    />
    <path d="M47.493 2.507A2.507 2.507 0 0150 0c27.611 0 50 22.389 50 50a2.507 2.507 0 11-5.013 0C94.987 25.157 74.843 5.013 50 5.013a2.507 2.507 0 01-2.507-2.506z" />
  </g>
));
